import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { routerLinks } from '@helpers/shared/router-links.const';
import { AlarisProfileService, PROFILE_SERVICE_INJECTOR, RouterDataLink } from '@campaign-portal/components-library';

@Component({
	selector: 'app-home',
	template: ``,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoHomeComponent {

	constructor(
		private readonly router: Router,
		@Inject(PROFILE_SERVICE_INJECTOR) private readonly profile: AlarisProfileService
	) {
		this.navigateToFirstAllowedRoute();
	}

	private navigateToFirstAllowedRoute(): void {
		const parentRedirects: Record<string, string> = {
			'dipping': 'dipping/rules',
			'reference_books': 'reference_books/currencies',
			'administration': 'administration/users'
		};

		const link: RouterDataLink | undefined = Object.values(routerLinks).find(
			(route: RouterDataLink) => this.profile.allowed(
				route.data.permissions,
				route.data.permissionComparison ?? 'every'
			)
		);

		const pathToNavigate = link ? (parentRedirects[link.path] ?? link.path) : '';

		if (pathToNavigate) {
			this.router.navigate([pathToNavigate]).then();
		} else {
			this.router.navigate(['']).then();
		}
	}
}